import React, { useState, useEffect } from "react";
import { Box, Menu, X, ChevronRight } from "lucide-react";

const navLinks = [
  { label: "Product", href: "#features" },
  { label: "How it works", href: "#workflow" },
  { label: "Workspace", href: "#workspace" },
  { label: "FAQ", href: "#faq" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-slate-200/80 bg-white/85 backdrop-blur-xl"
          : "border-b border-transparent bg-white/0"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-8">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-2.5">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-ink text-white">
            <Box className="h-4 w-4" strokeWidth={2} />
          </span>
          <span className="font-display text-[15px] font-extrabold tracking-tight text-ink">
            DeMaxtore
          </span>
          <span className="ml-1 hidden rounded-md border border-slate-200 bg-slate-50 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-slateink sm:inline">
            FullContainer™
          </span>
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-slateink transition-colors hover:text-ink"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <button
            data-testid="nav-signin"
            className="text-sm font-medium text-ink transition-colors hover:text-demax"
          >
            Sign in
          </button>
          <button
            data-testid="nav-cta"
            className="group inline-flex items-center gap-1.5 rounded-full bg-demax px-5 py-2.5 text-sm font-semibold text-white shadow-btn transition-all duration-200 hover:-translate-y-0.5 hover:bg-demax-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-demax focus-visible:ring-offset-2"
          >
            Create Workspace
            <ChevronRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-ink"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-slate-200 bg-white px-6 py-4 md:hidden" data-testid="mobile-menu">
          <div className="flex flex-col gap-4">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-sm font-medium text-slateink"
              >
                {l.label}
              </a>
            ))}
            <button className="mt-2 rounded-full bg-demax px-5 py-2.5 text-sm font-semibold text-white">
              Create Workspace
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
